import { render } from "./ProcessMuazaf.vue?vue&type=template&id=01b38198"
import script from "./ProcessMuazaf.vue?vue&type=script&lang=js"
export * from "./ProcessMuazaf.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__